<template>
  <div class="default-time-component">
    <div class="group-container">
      <div class="title first">
        {{ type }}
      </div>
      <div class="info-item-container" style="margin-top: 30px">
        <div class="info-title">Add Time For {{ type }}</div>
        <el-switch v-model="post.enabled"> </el-switch>
      </div>
    </div>
    <div class="info-container">
      <div class="mask-container" v-show="!post.enabled"></div>
      <div class="group-container">
        <div class="title">Frequency</div>
        <el-popover placement="right" width="100" trigger="click">
          <div class="frequency-modal">
            <div class="frequency-item">
              <!-- <div class="frequency-label">Daily</div> -->
              <el-radio v-model="post.frequencyType" :label="0">Daily</el-radio>
            </div>
            <div class="frequency-item">
              <!-- <div class="frequency-label">Custom</div> -->
              <el-radio v-model="post.frequencyType" :label="1"
                >Custom</el-radio
              >
            </div>
          </div>
          <div
            slot="reference"
            class="info-item-container"
            style="margin-top: 20px"
          >
            <div class="info-title frequency" style="width: 100%">
              {{ frequencyTypeText }}
            </div>
            <div class="right-icon"></div>
          </div>
        </el-popover>
      </div>
      <div class="group-container">
        <div class="title">
          <div>Time</div>
          <div>
            <hi-button class="btn" type="text" v-show="!edit" @click="editClick"
              >edit</hi-button
            >
            <hi-button class="btn" type="text" v-show="edit" @click="saveClick"
              >save</hi-button
            >
            <hi-button
              class="btn"
              type="text"
              v-show="edit"
              @click="cancelClick"
              >cancel</hi-button
            >
          </div>
        </div>
        <div class="time-picker-container" v-if="post.frequencyType !== 1">
          <time-picker
            @select="select(item)"
            @remove="remove(index)"
            v-model="item.time"
            :select="item.enabled"
            :edit="edit"
            v-for="(item, index) in post.times"
            :key="item.time"
          ></time-picker>
          <time-picker :add="true" @add="add" v-show="!edit"></time-picker>
        </div>
        <div class="time-picker-container" v-if="post.frequencyType === 1">
          <div
            :key="custom.week"
            v-for="(custom, weekIndex) in post.customFrequency"
          >
            <div class="time-title">{{ weekText(custom.week) }}</div>
            <time-picker
              @select="customSelect({ item })"
              @remove="customRemove({ weekIndex, index })"
              v-model="item.time"
              :select="item.enabled"
              :edit="edit"
              v-for="(item, index) in custom.times"
              :key="item.time"
            ></time-picker>
            <time-picker
              :add="true"
              :index="weekIndex"
              @add="customAdd"
              v-show="!edit"
            ></time-picker>
          </div>
        </div>
      </div>
      <div v-if="post.frequencyType === 0" class="group-container">
        <div class="title">Repeat</div>
        <div
          @click="$refs.mul.show = true"
          class="info-item-container"
          style="margin-top: 20px; cursor: pointer"
        >
          <div class="info-title" style="font-weight: initial">
            {{ repeatText }}
          </div>
          <div class="right-icon"></div>
        </div>
      </div>
      <div class="group-container">
        <div class="title">Time Zone</div>
        <div class="info-item-container" style="margin-top: 20px">
          <div class="info-title" style="width: 100%">
            <el-select v-model="post.timezone" class="post-tz">
              <el-option
                v-for="item in timezones"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="right-icon"></div>
        </div>
      </div>
    </div>
    <mul-menu ref="mul" v-model="post.repeat"></mul-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  TIMEZONE,
  CURRENT_USER_INFO,
} from "../../../store/mutation-types";
import { timezones } from "../../../const/timezone";
import timePicker from "../../../components/setting/time/Index";
import hiButton from "../../../components/common/button/Index";
import mulMenu from "../../../components/setting/mul-selector/Index";
import { weekType } from "../../../const/setting";
import _ from "lodash";
import moment from "moment-timezone";
import { updatePublisher } from "../../../service/publisher";
import { updateUserInfo } from "../../../service/user";
import { showErrorMsg } from "../../../utils/errors";

export default {
  name: "SettingDefaultTimePage",
  components: { timePicker, hiButton, mulMenu },
  props: {
    publisherId: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      timezone: TIMEZONE,
    }),
    frequencyTypeText() {
      if (this.post.frequencyType === 0) {
        return "Daily";
      } else if (this.post.frequencyType === 1) {
        return "Custom";
      }
      return "Daily";
    },
    repeatText() {
      // 7天都选择显示Every Day
      if (this.post.repeat.length === 7) {
        return "Every Day";
      } else {
        return this.post.repeat
          .map((r) => {
            return weekType.find((w) => w.key === r).abbreviation;
          })
          .join(", ");
      }
    },
  },
  methods: {
    customSelect({ item }) {
      item.enabled = !item.enabled;
    },
    customRemove({ weekIndex, index }) {
      this.post.customFrequency[weekIndex].times.splice(index, 1);
    },
    customAdd({ time, index }) {
      const times = this.post.customFrequency[index].times;
      console.log("触发一次customAdd");
      if (times.find((t) => t.time === time)) {
        this.$message({
          showClose: true,
          message: "Duplicated time error.",
          type: "error",
        });
        return;
      }
      times.push({
        time,
        enabled: true,
      });
      const timeList = times.sort((t1, t2) => {
        return moment(t1.time, "HH:mm").isAfter(moment(t2.time, "HH:mm"))
          ? 1
          : -1;
      });
      // 重新对时间进行排序
      this.$set(this.post.customFrequency[index].times, timeList);
    },
    weekText(week) {
      if (week === 0) {
        return "Sunday";
      } else if (week === 1) {
        return "Monday";
      } else if (week === 2) {
        return "Tuesday";
      } else if (week === 3) {
        return "Wednesday";
      } else if (week === 4) {
        return "Thursday";
      } else if (week === 5) {
        return "Friday";
      } else if (week === 6) {
        return "Saturday";
      }
    },
    showFrequencyModal() {
      // 显示切换Frequency
      this.showFrequency = true;
    },
    add({ time }) {
      // 首选判断是否添加重复的时间
      if (this.post.times.find((t) => t.time === time)) {
        this.$message({
          showClose: true,
          message: "Duplicated time error.",
          type: "error",
        });
        return;
      }
      this.post.times.push({
        time,
        enabled: true,
      });
      const timeList = this.post.times.sort((t1, t2) => {
        return moment(t1.time, "HH:mm").isAfter(moment(t2.time, "HH:mm"))
          ? 1
          : -1;
      });
      // 重新对时间进行排序
      this.$set(this.post.times, timeList);
    },
    select(item) {
      item.enabled = !item.enabled;
    },
    remove(index) {
      this.post.times.splice(index, 1);
    },
    editClick() {
      this.edit = true;
      // 保存编辑之前数据
      if (this.post.frequencyType === 0) {
        this.cloneTimes = _.cloneDeep(this.post.times);
        this.closeSelectIds = _.cloneDeep(this.post.selectedIds);
      } else {
        this.cloneCustom = _.cloneDeep(this.post.customFrequency);
      }
    },
    async saveClick() {
      this.edit = false;
      await this.saveDefaultTime(this.post);
    },
    cancelClick() {
      this.edit = false;
      if (this.post.frequencyType === 0) {
        this.$set(this.post, "times", this.cloneTimes);
      } else {
        this.$set(this.post, "customFrequency", this.cloneCustom);
      }
    },
    async saveDefaultTime(defaultTime) {
      // 格式化val 防止老数据影响
      const val = {
        timezone: defaultTime.timezone,
        frequencyType: defaultTime.frequencyType,
        customFrequency: defaultTime.customFrequency,
        enabled: defaultTime.enabled,
        repeat: defaultTime.repeat,
        times: defaultTime.times.map((t) => {
          const time = { time: t.time, enabled: t.enabled };
          if (time.enabled === undefined) {
            time.enabled = true;
          }
          return time;
        }),
      };
      const loading = this.$loading();
      try {
        // 获取当前publisher对应的id
        const selectPublisher = this.user.linkedInstagramList.find(
          (link) => link.publisherId === this.publisherId
        );
        const params = {
          id: selectPublisher.id,
        };
        if (this.type === "story") {
          params.default_post_time_story = val;
        } else if (this.type === "post") {
          params.default_post_time = val;
        }
        // 判断当前类型和选中的publisher 然后对更新后的数据进行保存
        const publisher = await updatePublisher(params);
        // 然后更新当前登录人中关于该publisher的信息
        const loginUser = this.$store.getters[CURRENT_USER_INFO];
        const publisherIndex = loginUser.publiships.findIndex(
          (p) => p.id === params.id
        );
        loginUser.publiships[publisherIndex].default_post_time =
          publisher.data.default_post_time;
        loginUser.publiships[publisherIndex].default_post_time_story =
          publisher.data.default_post_time_story;
        this.$store.commit(CURRENT_USER_INFO, loginUser);
        await updateUserInfo({});
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  watch: {
    post: {
      async handler(val, old) {
        if (!old || val.publisher !== old.publisher) {
          return;
        }
        if (this.edit) {
          return;
        }
        await this.saveDefaultTime(val);
      },
      deep: true,
    },
    publisherId: {
      async handler(publisherId, old) {
        if (!publisherId) {
          return;
        }
        try {
          const selectPublisher = this.user.linkedInstagramList.find(
            (link) => link.publisherId === publisherId
          );
          if (!selectPublisher) {
            return;
          }
          // 获取当前登录人的default time
          let form;
          if (this.type === "post") {
            form = selectPublisher.defaultPostTime;
          } else if (this.type === "story") {
            form = selectPublisher.defaultPostStoryTime;
          }
          if (form) {
            this.post = form;
          } else {
            this.post = {
              times: [
                { time: "10:00", enabled: true },
                { time: "16:00", enabled: true },
              ],
              repeat: [0, 1, 2, 3, 4, 5, 6],
              timezone: this.timezone,
              enabled: false,
            };
          }
          // 默认指定类型为daily
          if (this.post.frequencyType === undefined) {
            this.$set(this.post, "frequencyType", 0);
          }
          if (this.post.customFrequency === undefined) {
            this.$set(this.post, "customFrequency", []);
            // 如果没有customFrequency 则指定默认
            for (let i = 0; i < 7; i++) {
              this.post.customFrequency.push({
                week: i,
                times: [
                  { enabled: true, time: "10:00" },
                  { enabled: true, time: "16:00" },
                ],
              });
            }
          }
          if (!this.post.timezone) {
            this.post.timezone = this.timezone;
          }
          this.post.publisher = publisherId;
        } catch (e) {
          showErrorMsg(e);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      timezones,
      edit: false,
      cloneTimes: null,
      closeSelectIds: null,
      cloneCustom: null,
      showFrequency: false,
      post: {
        frequencyType: 0,
        customFrequency: [],
        enabled: false,
        selectedIds: ["1", "2"],
        times: [
          { id: "1", time: "10:00" },
          { id: "2", time: "16:00" },
        ],
        repeat: [0, 1, 2, 3, 4, 5, 6],
        timezone: this.timezone,
        send: true,
      },
    };
  },
};
</script>
<style lang="less">
.default-time-component {
  .el-input input {
    border: 0 !important;
    height: 19px !important;
    line-height: 16px;
    padding: 0 !important;
    font-size: 16px;
  }
  .post-tz {
    width: 100%;
    .el-input input {
      color: black !important;
    }
  }

  .el-input__prefix {
    display: none;
  }

  .el-input__suffix {
    display: none;
  }
}
</style>
<style scoped lang="less">
@import "../../../assets/style/theme.less";
.frequency-modal {
  padding: 7px 0 7px 10px;
  .frequency-item {
    padding: 8px 0;
    display: flex;
    align-items: center;
    .frequency-label {
      width: 100px;
    }
  }
}
.default-time-component {
  .info-container {
    position: relative;
    z-index: 1;
    .mask-container {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      background: rgba(255, 255, 255, 0.8);
    }
  }
  .group-container {
    border-bottom: solid 1px #e6e6e6;
    padding-top: 20px;
    .title {
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.first {
        margin-top: 20px;
        font-size: 20px;
        text-transform: capitalize;
      }
      .btn {
        text-transform: capitalize;
        padding: 0;
        margin-left: 10px;
        height: auto;
      }
    }
    .time-picker-container {
      padding: 10px 0 25px 0;
      .time-title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;
        text-transform: capitalize;
        border-bottom: solid 1px #e6e6e6;
      }
    }
    .info-item-container {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 10px;
      text-transform: capitalize;
      .post-tz {
        width: 100%;
      }
      .info-title {
        font-size: 16px;
        font-weight: 500;
        &.frequency {
          font-weight: normal;
        }
      }
      .right-icon {
        width: 8px;
        height: 14px;
        background-size: contain;
        background-image: url("../../../../public/images/schedule_posts/Date_Right@3x.png");
      }
    }
  }
}
</style>
